import axios from "../utils/axios.wrapper";

export const getTaxes = async () => {
    const { data } = await axios.get("/tax/active");
    return data.items || data;
};

export const getTaxById = async (id) => {
    const { data } = await axios.get(`/tax/${id}`);
    return data;
};

export const createTax = async (tax) => {
    const { data } = await axios.post("/tax/create", tax);
    return data;
};

export const updateTax = async (id, tax) => {
    const { data } = await axios.put(`/tax/${id}`, tax);
    return data;
};

export const deleteTax = async (id) => {
    const { data } = await axios.delete(`/tax/${id}`);
    return data;
};

export const getTaxByName = async (name) => {
  const { data } = await axios.get(`/tax/name/${name}`);
  //console.log("TAXX: ", data);
  return data;
};

export const taxesService = {
    getTaxes,
    getTaxById,
    createTax,
    updateTax,
    deleteTax,
    getTaxByName,
};
